if (!window.__voColorSwatchesBound) {
  window.__voColorSwatchesBound = true;

  const COLOR_OPTION_PATTERN = /color|colour|frame/i;
  const SIZE_OPTION_PATTERN = /^\s*size\b/i;
  const TYPE_OPTION_PATTERN = /^\s*type\b/i;

  const SWATCHES = {
    black: { color: '#1f1f1f', shine: 'linear-gradient(145deg, rgba(255,255,255,0.16) 0%, rgba(255,255,255,0) 46%, rgba(0,0,0,0.28) 100%)' },
    blue: { color: '#1e4aa8', shine: 'linear-gradient(145deg, rgba(255,255,255,0.22) 0%, rgba(255,255,255,0) 48%, rgba(0,0,0,0.22) 100%)' },
    brown: { color: '#6b3e26', shine: 'linear-gradient(145deg, rgba(255,255,255,0.18) 0%, rgba(255,255,255,0) 48%, rgba(0,0,0,0.24) 100%)' },
    copper: { color: '#a67c3a', shine: 'linear-gradient(145deg, #d7b36a 0%, #a67c3a 48%, #7a5420 100%)' },
    gold: { color: '#c4a227', shine: 'linear-gradient(145deg, #e8c95a 0%, #c4a227 46%, #8c7014 100%)' },
    green: { color: '#1b6a45', shine: 'linear-gradient(145deg, rgba(255,255,255,0.18) 0%, rgba(255,255,255,0) 48%, rgba(0,0,0,0.22) 100%)' },
    pink: { color: '#d989a0', shine: 'linear-gradient(145deg, rgba(255,255,255,0.28) 0%, rgba(255,255,255,0) 50%, rgba(0,0,0,0.12) 100%)' },
    red: { color: '#a51e28', shine: 'linear-gradient(145deg, rgba(255,255,255,0.18) 0%, rgba(255,255,255,0) 48%, rgba(0,0,0,0.22) 100%)' },
    silver: { color: '#9b9b9d', shine: 'linear-gradient(145deg, #d0d0d2 0%, #9b9b9d 48%, #6e6e70 100%)' },
    silvery: { color: '#9b9b9d', shine: 'linear-gradient(145deg, #d0d0d2 0%, #9b9b9d 48%, #6e6e70 100%)' },
    sliver: { color: '#9b9b9d', shine: 'linear-gradient(145deg, #d0d0d2 0%, #9b9b9d 48%, #6e6e70 100%)' },
    white: { color: '#e6e8e6', shine: 'linear-gradient(145deg, #ffffff 0%, #e6e8e6 55%, #cfd3d1 100%)', light: true },
    yellow: { color: '#d4b43a', shine: 'linear-gradient(145deg, #f0d56a 0%, #d4b43a 50%, #a88818 100%)' },
    'dark gray': { color: '#4a4c50', shine: 'linear-gradient(145deg, rgba(255,255,255,0.16) 0%, rgba(255,255,255,0) 48%, rgba(0,0,0,0.28) 100%)' },
    'dark grey': { color: '#4a4c50', shine: 'linear-gradient(145deg, rgba(255,255,255,0.16) 0%, rgba(255,255,255,0) 48%, rgba(0,0,0,0.28) 100%)' },
    gray: { color: '#4a4c50', shine: 'linear-gradient(145deg, rgba(255,255,255,0.16) 0%, rgba(255,255,255,0) 48%, rgba(0,0,0,0.28) 100%)' },
    grey: { color: '#4a4c50', shine: 'linear-gradient(145deg, rgba(255,255,255,0.16) 0%, rgba(255,255,255,0) 48%, rgba(0,0,0,0.28) 100%)' }
  };

  const titleCase = (value) =>
    String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\b[a-z]/g, (char) => char.toUpperCase());

  const rawTitle = (wrap) => {
    const title = wrap.querySelector('.bcpo-title');
    if (title && title.dataset.voBaseLabel) return title.dataset.voBaseLabel;
    const source = title || wrap.querySelector(':scope > label');
    return ((source && source.textContent) || '').replace(/:\s*[^:]*$/, ':').trim();
  };

  const prettyLabel = (raw) => {
    const stripped = String(raw || '')
      .replace(/:\s*[^:]*$/, '')
      .replace(/:$/, '')
      .replace(/\s+/g, ' ')
      .trim();
    const key = stripped.toLowerCase();
    if (/custom text here|your custom name|^custom text$|^custom name$/.test(key)) return 'Your Custom Name';
    if (/^size$/.test(key)) return 'Size';
    if (/^type$/.test(key)) return 'Type';
    if (COLOR_OPTION_PATTERN.test(key)) return 'Color';
    return titleCase(stripped);
  };

  const swatchFor = (value) => {
    const key = String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[_-]+/g, ' ');
    return SWATCHES[key] || null;
  };

  const setLabelText = (wrap, text) => {
    const title = wrap.querySelector('.bcpo-title');
    if (title) {
      if (!title.dataset.voBaseLabel) {
        title.dataset.voBaseLabel = prettyLabel(title.textContent);
      }
      if (title.textContent !== text) title.textContent = text;
      return;
    }
    const label = wrap.querySelector(':scope > label');
    if (label && label.textContent !== text) label.textContent = text;
  };

  const enhanceWrapper = (wrap) => {
    const source = rawTitle(wrap);
    const pretty = prettyLabel(source);

    if (COLOR_OPTION_PATTERN.test(source) || COLOR_OPTION_PATTERN.test(pretty)) {
      wrap.classList.add('bcpo-color-swatches');
      const checked =
        wrap.querySelector('.bcpo-front-button-option:checked') || wrap.querySelector('.bcpo-front-button-option');
      const colorName = titleCase(checked && checked.value);
      setLabelText(wrap, colorName ? `Color: ${colorName}` : 'Color');

      wrap.querySelectorAll('.bcpo-front-button-option').forEach((input) => {
        const label = wrap.querySelector(`label[for="${input.id}"]`) || input.nextElementSibling;
        if (!label || label.tagName !== 'LABEL') return;
        const swatch = swatchFor(input.value);
        if (!swatch) return;
        label.style.setProperty('--swatch-color', swatch.color);
        label.style.setProperty('--swatch-shine', swatch.shine);
        if (swatch.light) label.setAttribute('data-swatch-light', 'true');
        if (!label.getAttribute('title')) label.setAttribute('title', input.value);
        if (!label.getAttribute('aria-label')) label.setAttribute('aria-label', input.value);
      });
      return;
    }

    if (SIZE_OPTION_PATTERN.test(source) || pretty === 'Size') {
      wrap.classList.add('bcpo-size-pills');
      setLabelText(wrap, 'Size');
      return;
    }

    if (TYPE_OPTION_PATTERN.test(source) || pretty === 'Type') {
      wrap.classList.add('bcpo-type-pills');
      setLabelText(wrap, 'Type');
      return;
    }

    setLabelText(wrap, pretty);
  };

  let updating = false;
  const enhanceAll = () => {
    if (updating) return;
    updating = true;
    document.querySelectorAll('#bcpo .selector-wrapper').forEach(enhanceWrapper);
    updating = false;
  };

  const start = Date.now();
  const timer = setInterval(() => {
    if (document.querySelector('#bcpo .selector-wrapper')) {
      enhanceAll();
      const root = document.querySelector('#bcpo');
      if (root && !root.dataset.voOptionUiBound) {
        root.dataset.voOptionUiBound = 'true';
        root.addEventListener(
          'change',
          (event) => {
            if (!event.target || !event.target.classList.contains('bcpo-front-button-option')) return;
            enhanceAll();
          },
          false
        );
        new MutationObserver(enhanceAll).observe(root, { childList: true, subtree: true });
      }
      clearInterval(timer);
    } else if (Date.now() - start > 8000) {
      clearInterval(timer);
    }
  }, 100);
}
